<template>
  <div class="about">
    <div class="container">
      <div class="banner">
        <div class="auto-container">
          <h1>关于</h1>
          <p>
            <a href="/">首页</a>
            <Icon class="arrow" type="ios-arrow-forward" />关于
          </p>
        </div>
      </div>
      <!-- 公司简介 -->
      <div class="heading">
        <h2 class="introduction">公司简介</h2>
      </div>
      <div class="auto-container">
        <p>
          <strong>上海曜宁信息科技有限公司</strong>
          上海曜宁信息科技有限公司 是专业从事中小幼、中高职智慧校园软件开发的企业，公司技术实力雄厚，智慧教育产品多样。公司具备国家高新技术企业、上海市创新型中小企业、双软企业资质、拥有软件著作权40余项，同时质量体系通过ISO9001认证，AAA级信用企业，为数百家教育单位提供优质的信息化服务。
        </p>
        <img
          src="https://www.rayscloud.cn/webapi/upload/editor/2022/02/21/254bc593-e97a-4f97-849c-26f205e1c1e3_O.png"
          alt=""
        />
        <p style="padding-bottom: 1rem"><strong>人员构成</strong></p>
        <p style="padding-bottom: 1rem">
          公司拥有上海、常州二个研发中心，专职研发人员40余名，核心研发成员均来教育系统信息技术岗位或具备国内知名教育行业 IT 业任职经历。
        </p>
        <p style="padding-bottom: 1rem"><strong>技术优势</strong></p>
        <p>
          公司拥有校帮校级数字基座、校帮低代码智慧搭建平台、学生成长评价成长画像、教师研修与发展平台、智慧物联融合平台、智慧生态、中高职学生实习就业平台、智慧屏幕、校智联边缘计算融合器等业内领先的软硬件技术平台。
          <br>
          近年来，公司在传统智慧校园基础上融入AIGC元素，致力于AIGC智慧校园的打造，将生成式人工智能技术用于产品各细节，未来会有更多更先进的技术提供给我们的客户。
        </p>
        <img
          src="https://www.rayscloud.cn/webapi/upload/editor/2022/02/21/7edc6f01-3357-4ca3-ab5f-602067d4e37b_O.png"
          alt=""
        />
      </div>
      <!-- 计算机软件著作权 -->
      <div class="bg">
        <div class="heading">
          <p class="bottom">COPYRIGHT</p>
          <h2 class="copyRight">计算机软件著作权</h2>
        </div>
        <div class="auto-container">
          <Row>
            <Col span="4" :xs="8" v-for="(item, index) in rightList" :key="index">
              <div class="rightList">
                <img :src="item.img" alt="" />
                <p>{{ item.title }}</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <!-- 软件产品证书 -->
      <div class="heading">
        <h2 class="certificate">软件产品证书</h2>
      </div>
      <div class="auto-container certifList">
        <Row>
          <Col span="4" :xs="8" v-for="(item, index) in certifList" :key="index">
            <div class="rightList">
              <img :src="item.img" alt="" />
              <p>{{ item.title }}</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import about from "./index.js";
export default about;
</script>

<style lang="less" scoped>
@import "./index.less";
</style>